import { useEffect, useMemo, useState } from "react";
import { useTours } from "@/lib/siteData";
import { STATUS, rpc, spDay, useAdminBookings, useAdminSlots, bookingDay } from "@/lib/booking";
import { Card, Field, Select, PageTitle, Notice, inputCls } from "./adminUI";
import { BookingCard } from "./BookingCard";
import { NewBookingForm } from "./NewBookingForm";

export default function ReservationsAdmin({ role }) {
    const tours = useTours(true);
    const bookings = useAdminBookings();
    const slots = useAdminSlots();
    const [tab, setTab] = useState("lista");
    const [f, setF] = useState({ q: "", status: "", day: "" });
    useEffect(() => { rpc("expire_booking_holds", {}).catch(() => {}); }, []);
    const slotsById = useMemo(() => Object.fromEntries((slots.data || []).map((s) => [s.id, s])), [slots.data]);
    const toursById = Object.fromEntries(tours.map((t) => [t.id, t]));
    const q = f.q.toLowerCase();
    const list = (bookings.data || []).filter((b) => (!f.status || b.status === f.status)
        && (!f.day || bookingDay(b, slotsById) === f.day)
        && (!q || [b.customer_name, b.customer_email, b.customer_phone, b.code].join(" ").toLowerCase().includes(q)));
    const futureSlots = (slots.data || []).filter((s) => s.active && new Date(s.starts_at) > new Date());

    return (
        <div className="space-y-6">
            <PageTitle title="Reservas">Solicitações, confirmações, reagendamentos, pagamentos manuais e reembolsos.</PageTitle>
            <div className="flex flex-wrap gap-2">
                {[["lista", "Reservas"], ["nova", "+ Reserva administrativa"]].map(([id, t]) => (
                    <button key={id} onClick={() => setTab(id)} data-testid={`reservations-tab-${id}`}
                        className={`rounded-full border px-4 py-2 text-xs ${tab === id ? "border-neon-cyan text-neon-cyan" : "border-ink/20 text-dim"}`}>{t}</button>
                ))}
            </div>
            {bookings.isError && <Notice tone="amber" testid="reservations-db-error">Não foi possível carregar as reservas. Verifique se supabase/reservas.sql e supabase/plataforma.sql foram aplicados.</Notice>}
            {tab === "nova" ? <NewBookingForm tours={tours} slots={futureSlots} onCreated={() => setTab("lista")} /> : <>
                <Card className="grid gap-4 sm:grid-cols-3">
                    <Field label="Pesquisar cliente ou código" value={f.q} onChange={(v) => setF({ ...f, q: v })} testid="reservations-search" />
                    <Select label="Status" value={f.status} onChange={(v) => setF({ ...f, status: v })} testid="reservations-filter-status"
                        options={[["", "Todos"], ...Object.entries(STATUS)]} />
                    <label className="block"><span className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.25em] text-neon-cyan">Data</span>
                        <input type="date" className={inputCls} value={f.day} data-testid="reservations-filter-day" onChange={(e) => setF({ ...f, day: e.target.value })} /></label>
                </Card>
                <div className="flex gap-3 text-xs text-dim">
                    <span data-testid="reservations-count">{list.length} reserva(s)</span>
                    <button className="text-neon-cyan" onClick={() => setF({ q: "", status: "", day: spDay(new Date()) })}>Hoje</button>
                </div>
                {list.map((b) => (
                    <BookingCard key={b.id} b={b} tour={toursById[b.tour_id]} slot={slotsById[b.slot_id]} role={role}
                        slots={futureSlots.filter((s) => s.tour_id === b.tour_id && s.id !== b.slot_id)} />
                ))}
            </>}
        </div>
    );
}
